module.exports = require("core-js/library/fn/number/is-nan");